
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2014-08-29-brooklyn-bridge",
      function () {
        return require("private-next-pages/posts/2014-08-29-brooklyn-bridge.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2014-08-29-brooklyn-bridge"])
      });
    }
  